import { filterRoadmapGoals } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useRoadmapFilteredGoals = () => {
  const user = useUser();
  const goals = useGoals();

  return useMemo(
    () =>
      filterRoadmapGoals(goals, user?.settings?.goalsOverview?.roadmap ?? {}),
    [goals, user?.settings?.goalsOverview?.roadmap],
  );
};
